export default "__VITE_ASSET__BYw8mVzp__"